import { useStaticQuery, graphql } from 'gatsby';

import type { TMinimalTranslation } from '@klaviyo-mkt/marketing-cms/src/staticTypes';

import type { ISiteSettings } from '../../types';

// These are rank ordered
const xDefaults = [
  'en-us',
  'en-gb',
];

export const HrefLang = ({
  noIndexNoFollow = false,
  translations = [],
}: {
  noIndexNoFollow?: boolean;
  translations?: TMinimalTranslation[];
}) => {
  const data: ISiteSettings = useStaticQuery(graphql`
    query HrefLangQuery {
      wp {
        sites {
          hreflang
          includeInHfrelangTags
        }
      }
    }
  `);

  const exclusions = data?.wp?.sites?.map(({ includeInHfrelangTags, hreflang }) => includeInHfrelangTags === false ? hreflang : '').filter(Boolean) || [];
  const filteredTranslations = translations.filter(({ hreflang }) => !exclusions.includes(hreflang));
  const xDefault = filteredTranslations.find(({ hreflang }) => xDefaults.includes(hreflang));

  if (noIndexNoFollow) {
    return null;
  }

  return (
    <>
      {filteredTranslations.map(({ hreflang, url }) => (
        <link key={hreflang} rel="alternate" href={url} hrefLang={hreflang} />
      ))}
      {xDefault && (
        <link rel="alternate" hrefLang="x-default" href={xDefault.url} />
      )}
    </>
  );
};
